import ErrorNotFoundPage from '$landing-page/site-pages/error-not-found-page';

export default ErrorNotFoundPage;
